import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var CompareIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M1 4a2 2 0 012-2h6a2 2 0 012 2v16a2 2 0 01-2 2H3a2 2 0 01-2-2V4zm2 0v16h6V4H3zM21 19v1h-1a1 1 0 100 2h1a2 2 0 002-2v-1a1 1 0 10-2 0zM21 5V4h-1a1 1 0 110-2h1a2 2 0 012 2v1a1 1 0 11-2 0zM15 19v1h1a1 1 0 110 2h-1a2 2 0 01-2-2v-1a1 1 0 112 0zM15 5V4h1a1 1 0 100-2h-1a2 2 0 00-2 2v1a1 1 0 102 0zM22 7a1 1 0 011 1v2a1 1 0 11-2 0V8a1 1 0 011-1zM22 13a1 1 0 011 1v2a1 1 0 11-2 0v-2a1 1 0 011-1zM14 7a1 1 0 011 1v2a1 1 0 11-2 0V8a1 1 0 011-1zM14 13a1 1 0 011 1v2a1 1 0 11-2 0v-2a1 1 0 011-1z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
CompareIcon.isCarinaIcon = true;
export default CompareIcon;
